<template>
  <v-toolbar flat>
    <div
      style="width: 150px" class="mr-2">
      <ejercicio-picker
        v-model="filtros.ejercicio"
        class="mr-2">
      </ejercicio-picker>
    </div>
    <filtros
      :contratos="listaContratos"
      :filtros="filtros">
    </filtros>
    <v-spacer></v-spacer>
  </v-toolbar>
</template>

<script>
import Filtros from './Filtros.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';

export default {
  name: 'ToolBarContratos',
  props: {
    listaContratos: {
      type: Array,
      required: true,
    },
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    EjercicioPicker,
    Filtros,
  },
  data() {
    return {
    };
  },
  methods: {
    limpiarBuscadorTexto() {
      this.filtros.buscarTexto = '';
    },
  },
};
</script>

<style lang="scss">
</style>
